var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18.4,
    viewBox: "0 0 16 18.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spreadsheet"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45,19.24c-.26,0-.61-.09-.87-.09A3.16,3.16,0,0,1,.77,16.44a6.37,6.37,0,0,1-.09-1.23V5A4.69,4.69,0,0,1,.86,3.46,3.18,3.18,0,0,1,3.58,1.09,12.74,12.74,0,0,1,5.33,1H9.71a.89.89,0,0,1,1.14.51.88.88,0,0,1-.51,1.13.83.83,0,0,1-.54,0H3.93A1.55,1.55,0,0,0,2.35,4.16V15.65a1.42,1.42,0,0,0,.09.61,1.6,1.6,0,0,0,1.4,1.32h7.63a5.48,5.48,0,0,0,1.14-.09,1.5,1.5,0,0,0,1.23-1.32c0-.35.08-.61.08-1V10.3a1,1,0,0,1,.27-.7.78.78,0,0,1,1.12,0,.67.67,0,0,1,.19.28c0,.09.09.09.09.18v5.78c0,.18-.09.44-.09.62a3.15,3.15,0,0,1-2.8,2.71c-.27,0-.62.09-.88.09Z",
    transform: "translate(-0.63 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.19 6.57) rotate(-0.27)",
    fontSize: 4.7,
    fill: "#d81b60",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "PDF")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPdf);
export default __webpack_public_path__ + "static/media/documentPDF.a5ebe175839a950cfab403f979c069cd.svg";
export { ForwardRef as ReactComponent };